export default "__VITE_ASSET__Tz77era9__"